import React, { useState, useEffect } from 'react';
import '../styles/editModal.css';
import '../styles/leagueManagement.css';

export default function EditChampionatModal({ isOpen, onClose, onSave, championat }) {
    const [name, setName] = useState('');
    const [priority, setPriority] = useState('1');

    useEffect(() => {
        if (isOpen && championat) {
            setName(championat.name || '');
            setPriority(String(championat.priority !== undefined && championat.priority !== null ? championat.priority : 1));
        }
    }, [isOpen, championat]);

    if (!isOpen || !championat) return null;

    const parsedPriority = parseInt(priority, 10);
    const priorityValid = !isNaN(parsedPriority) && parsedPriority >= 0;
    const canSave = name.trim().length > 0 && priorityValid;

    const handleSave = () => {
        if (!canSave) return;
        onSave({ name: name.trim(), priority: parsedPriority });
        onClose();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSave();
        else if (e.key === 'Escape') onClose();
    };

    return (
        <div className="modalOverlay" onClick={onClose}>
            <div className="modalContent modalContentWide" onClick={(e) => e.stopPropagation()}>
                <div className="modalHeader">
                    <h2>Редактирование чемпионата</h2>
                    <button className="modalClose" onClick={onClose}>×</button>
                </div>
                <div className="modalBody">
                    <div className="lmRow">
                        <label className="modalLabel">ID чемпионата</label>
                        <div className="readonlyValue">{championat.id}</div>
                    </div>

                    <div className="lmRow">
                        <label className="modalLabel">Название чемпионата</label>
                        <input
                            type="text"
                            className="modalInput"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            onKeyDown={handleKeyDown}
                            autoFocus
                            maxLength={100}
                            placeholder="Введите название чемпионата"
                        />
                    </div>

                    <div className="lmRow">
                        <label className="modalLabel">Приоритет</label>
                        <input
                            type="number"
                            className="modalInput"
                            value={priority}
                            min={0}
                            onChange={(e) => setPriority(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        <span className="fieldHint">
                            Чем меньше число, тем выше чемпионат в списке.
                        </span>
                        {!priorityValid && (
                            <span className="fieldError">Приоритет должен быть целым числом от 0.</span>
                        )}
                    </div>
                </div>
                <div className="modalFooter">
                    <button className="modalButton modalButtonCancel" onClick={onClose}>
                        Отмена
                    </button>
                    <button
                        className="modalButton modalButtonSave"
                        onClick={handleSave}
                        disabled={!canSave}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    );
}
